/** Created by azhou on 2019/3/25.*/
<template>
  <ul class="list-item">
    <li class="w-50 list-item-col">
      <span class="text-link" v-if="$route.query.storeType == 4" @click="$router.push({name:'StoreDetail',query:{type:4, id:item.travel_id, look: 0}})">{{item.title || item.travelName}}</span>
      <span class="text-link" v-else @click="$emit('goStoreDetail',storeId)">{{item.title || item.travelName}}</span>
    </li>
    <li class="w-50 list-item-col">{{item.pay/100 | formatMoney}} 元</li>
    <li class="w-50 list-item-col-end">
      <span class="text-link" @click="$emit('goDetailList','1',storeId,item.travelName || item.title)">查看流水明细</span>
    </li>
  </ul>
</template>

<script>

  export default {
    name: 'PayList',
    props:{
      item:{}
    },
    computed:{
      storeId() { return this.item.terminal_id || this.item.travel_id }
    }
  }
</script>
